import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { IoMdStar } from 'react-icons/io'

const StartStyled = styled(IoMdStar)`
  color: var(--neutral80);
  &.is-active {
    color: #FFDD66;
  }
`

const StarsStyled = styled.div`
  display: grid;
  grid-template-columns: repeat(5, ${({ size }) => `${size}px`});
  grid-column-gap: ${({ gap }) => `${gap}px`};
  justify-content: ${({ align }) => align};
  @media(min-width: 768px) {
    justify-content: ${({ alignLarge }) => alignLarge};
  }
`

function Stars({ stars, align, alignLarge, size, gap }) {
  const [starsActive, setStarsActive] = useState([
    { active: false, id: '0' },
    { active: false, id: '1' },
    { active: false, id: '2' },
    { active: false, id: '3' },
    { active: false, id: '4' },
  ])
  useEffect(() => {
    const array = []
    for (let i = 0; i < stars; i += 1) {
      array.push({ active: true, id: i })
    }
    if (array.length < 5) {
      const missing = 5 - array.length
      for (let i = 0; i < missing; i += 1) {
        array.push({ active: false, id: i })
      }
    }
    setStarsActive(array)
  }, [stars])
  return (
    <StarsStyled gap={gap} size={size} align={align} alignLarge={alignLarge}>
      {starsActive.map((star) => (
        <StartStyled
          key={star.id}
          className={star.active ? 'is-active' : ''}
          size={size}
        />
      ))}
    </StarsStyled>
  )
}

Stars.defaultProps = {
  align: 'center',
  alignLarge: 'start',
  stars: 5,
  size: 28,
  gap: 8,
}

Stars.propTypes = {
  align: PropTypes.string,
  alignLarge: PropTypes.string,
  stars: PropTypes.number,
  size: PropTypes.number,
  gap: PropTypes.number,
}

export default Stars
